import APIService from "@utils/apiService";
import _ from "lodash";
import cx from "classnames";
class Service {
  config: any;
  constructor(config: any) {
    this.config = config;
  }
  async find(query: any) {
    // TODO Query.
    const handler: any = {
      string: async (id: string) => {
        return await APIService.get(`/api/offers/${id}`);
      },
      number: async (id: string) => {
        return await APIService.get(`/api/offers/${id}`);
      },
      object: async ({ id, ...params }: any) => {
        return await APIService.get(`/api/offers/${cx(id)}`, { params });
      },
    };
    const typeQuery = typeof query;
    if (_.isFunction(handler[typeQuery]))
      return await handler[typeQuery](query);
    return null;
  }
  async search(urlQuery: string) {
    const res = await APIService.get(
      `/api/offers${cx({ "?": urlQuery[0] !== "?" })}${urlQuery}`
    );
    return res;
  }
}
const Model = new Service({});

export default Model;
